<template>
  <div class="why-choose-us ptb-80 pt-0">
    <div class="container">
      <div class="row py-5">
        <div class="col-lg-6 col-md-12">
          <div class="d-flex flex-column">
            <div class="section-title tw-mb-12.5">
              <h2 class="pb-3">
                <well-formatted-title :blackArea="politiqueTitle" />
              </h2>
              <p class="tw-max-w-full">
                En tant qu'ESN engagée, WORLDATA TEAM reconnaît l'importance de
                jouer un rôle actif dans la construction d'un avenir meilleur
                pour tous.
              </p>
              <p class="tw-max-w-full">
                Nous nous efforçons de placer la RSE au cœur de notre stratégie
                d'entreprise et de faire de notre mieux pour avoir un impact
                positif sur la société et l'environnement.
              </p>
              <p class="pt-4 tw-max-w-full">
                {{ APP_NAME }} s’unit autour d’une politique RSE fédératrice et
                implique ses collaborateurs autour de projets utiles et
                valorisants.
              </p>
             <!--  <router-link to="/doc-ressources" class="btn btn-primary">Voir les ressources</router-link> -->
            </div>

            <div class="why-choose-us-image">
              <div
                class="tw-h-full tw-w-full d-none d-lg-flex tw-relative tw-justify-center"
              >
                <img
                  src="../../../../assets/img/services-left-image/cercle-shape.png"
                  class="rotateme tw-left-0"
                  alt="image"
                />
              </div>
              <div
                class="lg:tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0 tw-flex tw-justify-center"
              >
                <div class="my-auto">
                  <img
                    src="../../../../assets/img/engagements-rse/5-rse.png"
                    alt="image"
                    class="tw-left-0 tw-w-[400px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="row">
            <div
              class="col-lg-6 col-md-6 col-sm-6 mb-3"
              v-for="section in sections"
              :key="section.id"
            >
              <div class="single-why-choose-us m-0 h-100">
                <div class="icon">
                  <i :class="section.icon"></i>
                </div>
                <h3>{{ section.title }}</h3>
                <p>{{ section.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WellFormattedTitle from "../../../generics/Typography/Divider/WellFormattedTitle.vue";
export default {
  components: { WellFormattedTitle },
  name: "EngagementRsePolitique",
  props: {
    cmsDocsByVar: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    politiqueTitle() {
      return this.getBodyText("politique-title", "Politique RSE");
    },
    intro1() {
      return this.getBodyHtml(
        "intro-1",
        "<p>En tant qu'ESN engagee, WORLDATA TEAM reconnait l'importance de jouer un role actif dans la construction d'un avenir meilleur pour tous.</p>"
      );
    },
    intro2() {
      return this.getBodyHtml(
        "intro-2",
        "<p>Nous nous efforcons de placer la RSE au coeur de notre strategie d'entreprise et de faire de notre mieux pour avoir un impact positif sur la societe et l'environnement.</p>"
      );
    },
    intro3() {
      return this.getBodyHtml(
        "intro-3",
        "<p>WORLDATA TEAM s'unit autour d'une politique RSE federatrice et implique ses collaborateurs autour de projets utiles et valorisants.</p>"
      );
    },
    resourcesCta() {
      return this.getBodyText("resources-cta", "Voir les ressources");
    },
    sections() {
      return [
        {
          id: 1,
          icon: "flaticon-team",
          title: this.getDocLabel("responsabilite-sociale", "La responsabilite Sociale"),
          description: this.getBodyText(
            "responsabilite-sociale",
            "Respecter les droits des individus et promouvoir l'equite sociale a travers nos actions."
          ),
        },
        {
          id: 2,
          icon: "flaticon-rocket",
          title: this.getDocLabel(
            "responsabilite-organisationnelle",
            "La responsabilite Organisationnelle"
          ),
          description: this.getBodyText(
            "responsabilite-organisationnelle",
            "Integrer toutes les parties prenantes a notre strategie"
          ),
        },
        {
          id: 3,
          icon: "flaticon-shield",
          title: this.getDocLabel("responsabilite-societale", "La responsabilite Societale"),
          description: this.getBodyText(
            "responsabilite-societale",
            "Creer de la valeur a long terme pour la societe dans son ensemble en oeuvrant pour un developpement durable"
          ),
        },
        {
          id: 4,
          icon: "flaticon-diamond",
          title: this.getDocLabel(
            "responsabilite-environnementale",
            "La responsabilite environnementale"
          ),
          description: this.getBodyText(
            "responsabilite-environnementale",
            "Integration d'une dimension environnementale a tous les niveaux de nos activites"
          ),
        },
      ];
    },
  },
  methods: {
    getDoc(varName) {
      return this.cmsDocsByVar?.[varName] || null;
    },
    getBodyHtml(varName, fallback) {
      return this.getDoc(varName)?.body || fallback;
    },
    getBodyText(varName, fallback) {
      const html = this.getBodyHtml(varName, fallback);
      return String(html).replace(/<[^>]*>/g, "").trim() || fallback;
    },
    getDocLabel(varName, fallback) {
      return this.getDoc(varName)?.label || fallback;
    },
  },
};
</script>
